import { render } from "./PivotOrdering.vue?vue&type=template&id=34873506&ts=true"
import script from "./PivotOrdering.vue?vue&type=script&lang=ts"
export * from "./PivotOrdering.vue?vue&type=script&lang=ts"

import "./PivotOrdering.vue?vue&type=style&index=0&id=34873506&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__